import Immutable from 'immutable';
import {
  GALLERY_HIDE_POST,
  GALLERY_SET_FILTERS,
  PORTFOLIO_QUERY_COMPLETE,
  FETCH_GALLERY_POSTS_SUCCESS,
} from './actions';
import { PORTFOLIO_POST_SET_MANY } from '../Posts/actions';

const DEFAULT_STATE = Immutable.fromJS({
  byQueryId: {},
  filtersByQueryId: {},
  byPortfolioId: {},
});

export function Galleries(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case FETCH_GALLERY_POSTS_SUCCESS: {
      const { queryId, gallery } = action;
      gallery.lastRefresh = Date.now();
      return state.set(
        'byQueryId',
        state.get('byQueryId').set(queryId, Immutable.fromJS(gallery))
      );
    }
    case GALLERY_HIDE_POST: {
      // state.byQueryId
      let newState = state;

      const keys = newState.get('byQueryId').keys();
      const queriesWithPost = [...keys].filter((queryKey) => {
        const postIds = newState.getIn(
          ['byQueryId', queryKey, 'postIds'],
          false
        );

        if (!postIds) {
          return false;
        }

        return postIds.contains(action.postId);
      });

      queriesWithPost.forEach((queryKey) => {
        const postIds = newState.getIn(['byQueryId', queryKey, 'postIds']);
        newState = newState.setIn(
          ['byQueryId', queryKey, 'postIds'],
          postIds.remove(action.postId)
        );
      });

      return newState;
    }
    case GALLERY_SET_FILTERS: {
      return state.setIn(
        ['filtersByQueryId', action.queryKey],
        Immutable.fromJS(action.filters)
      );
    }
    case PORTFOLIO_QUERY_COMPLETE: {
      const { profileName, posts, counter } = action;
      let newState = state.setIn(['byPortfolioId', profileName], counter);
      const postIds = posts.map((post) => post.id);

      newState = newState.setIn(
        ['byPortfolioId', profileName, 'posts'],
        Immutable.fromJS(postIds)
      );

      return newState;
    }
    case PORTFOLIO_POST_SET_MANY: {
      const { profileName, postIds, isPortfolioOn } = action;
      const oriCounter = state.getIn(['byPortfolioId', profileName]);
      let newState = state;

      if (oriCounter) {
        if (isPortfolioOn) {
          newState = newState.setIn(
            ['byPortfolioId', profileName, 'show'],
            oriCounter.get('show') + postIds.size
          );
          newState = newState.setIn(
            ['byPortfolioId', profileName, 'hide'],
            oriCounter.get('hide') - postIds.size
          );
        } else {
          newState = newState.setIn(
            ['byPortfolioId', profileName, 'show'],
            oriCounter.get('show') - postIds.size
          );
          newState = newState.setIn(
            ['byPortfolioId', profileName, 'hide'],
            oriCounter.get('hide') + postIds.size
          );
        }

        return newState;
      }
      return state;
    }
    default: {
      return state;
    }
  }
}
